import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionsTimelineComponent } from './transport-interventions-timeline.component';
import {DxScrollViewModule} from 'devextreme-angular';
import {IconModule} from '@visurel/iconify-angular';



@NgModule({
  declarations: [TransportInterventionsTimelineComponent],
  imports: [
    CommonModule,
    DxScrollViewModule,
    IconModule
  ],
  exports: [TransportInterventionsTimelineComponent]
})
export class TransportInterventionsTimelineModule { }
